import styled from 'styled-components';
import { Box, Theme } from '@material-ui/core';

const theme = (props: any) => {
  return props.theme as Theme;
}

export const Delimiter = styled(Box)(props => ({
  margin: 'auto',
})) as typeof Box;